import styles from './style.module.scss';
import { useState, useRef, useEffect } from 'react';
import FullScreenVideo from '/components/commonComponents/fullScreenVideo';
import { src } from '../../../utils/common';
import { useWebPResourceCompatibleFn } from '../../../hooks/useWebPResource';

const VideoCard = ({ videoUrl, poster }) => {
  const [show, setShow] = useState(false);
  const videoRefs = useRef('');
  const webPResourceHandleFn = useWebPResourceCompatibleFn();

  return (
    <section className={styles['video-wrapper']}>
      <video
        className={styles['video-item']}
        src={videoUrl}
        poster={webPResourceHandleFn(src(poster))}
        ref={(el) => (videoRefs.current = el)}
        loop
        muted
        controls
        preload="auto"
        // eslint-disable-next-line react/no-unknown-property
        webkit-playsinline="true"
        // eslint-disable-next-line react/no-unknown-property
        playsInline={true}
        // eslint-disable-next-line react/no-unknown-property
        x5-playsinline
      />
    </section>
  );
};

export default VideoCard;
